/** * * Asynchronously loads the component for
Phone Base
* */ import { lazyLoad } from "utils/loadable";
export const PhoneBase = lazyLoad(
  () => import("./index"),
  (module) => module.PhoneBase
);
